module.exports = __webpack_public_path__ + "img/n3.6e11efb2.jpg";